import { objectTypes } from "src/consts/objectTypes";
import { InspectionFinishCategory } from "./InspectionFinishCategory";
import { InspectionStatus } from "./InspectionStatus";
import {
  AssignmentResponse,
} from "src/api/hooks/useAssignment";

export interface InspectionUpdateRequest {
  id: number;
  locationGuid: string | undefined;
  deviationType: string | undefined;
  status: InspectionStatus | undefined;
  title: string | undefined;
  description: string | undefined;
  userId: number | undefined;
  companyId: number | undefined;
  externalId?: string | undefined; // This is the external id of the inspection
  category: string | undefined;
  groupId: number | undefined;
  assignedToUserId: number | undefined;
  information: string | undefined;
  closingRemarks: string | undefined;
  calculatedPrice: number | undefined;
  customer: string | undefined;
  objectType: keyof typeof objectTypes | undefined;
  finishCategory: InspectionFinishCategory | undefined;
  parentDeviationId: number | undefined;
}

interface ImageResponse {
  urlx32: string;
  urlx240: string;
  urlx1080: string;
  urlOriginal: string;
}

export interface Position {
  latitude: number;
  longitude: number;
  geometry: any;
  adress: string;
  id?: number;
}
export enum FileType {
  Image = "Image",
  Document = "Document",
  Signature = "Signature",
  Schema = "Schema",
  FormResponse = "FormResponse",
  Map = "MapFile",
}
export interface SasFileResult {
  id?: number;
  files: string[];
  comment: string;
  groupId?: number;
  markerColor?:string;
  markerBorder?:string;
  boundingBox?: string;
  file?: File;
  action?: string;
  exif?: string;
  fileName: string;
  deviationId?: number | null;
  companyId: number | null;
  depiction: string;
  fileType: FileType;
  webUrl?: string;
  url?: string;
  schemaId?: string;
  imageResponse?: ImageResponse | null | undefined;
  position?: Position | null | undefined;
  lastSignedDocument?: string;
  signatures?: any[];
}
interface GroupResponse {
  id: number;
  name: string;
  companyId: number;
  costCenter: string;
}
interface UserResponse {
  id: number;
  firstName: string;
  surname: string;
  username: string;
  phone: string;
  objectId: string;
  city: string;
  zipCode: string;
  country: string;
  companyId: number;
}

export interface InspectionResponse {
  id: number;
  title: string;
  customer: string;
  userId: number;
  groupId: number | null;
  companyId: number;
  assignedToUserID: number | null;
  description: string;
  calculatedPrice: number | null;
  information: string | null;
  category: string;
  group: GroupResponse;
  externalId?: string | undefined; // This is the external id of the inspection
  user: UserResponse;
  deviationType: string;
  status: string;
  latitude: number | null;
  longitude: number | null;
  objectType: keyof typeof objectTypes | undefined;
  finishCategory: string | null;
  closingRemarks: string | null;
  parentDeviationId: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  syncId: string;
  locationGuid: string | null;
  imageUrls: string[] | null;
  files: SasFileResult[];
  children: InspectionResponse[];
  assignments: AssignmentResponse[];
  position: Position;
}
